import React from "react"
import { LayoutRecommendations } from "trimble-terra"
import { formatCommonComponentFields } from "./formatLayoutFunctions"
import renderPaddingOrFullBleed from "../renderPaddingOrFullBleed"
import formatPageLinks from "../formatPageLinks"
import formatIcons from "../formatIcons"
import { formatThemePreset } from "../formatTheme"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import { formatFocusedImage } from "../formatBaseMolecules"

const FormatAndRenderLayoutProductRecommendations = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
  passthroughProps,
}) => {
  // For personalization variants, use passthroughProps; otherwise use props from baseline
  const activeLocale = passthroughProps?.locale || locale
  const activeSiteIdentifier = passthroughProps?.siteIdentifier || siteIdentifier
  const activeHomepageSlug = passthroughProps?.homepageSlug || homepageSlug
  const activeCurrentSpaceId = passthroughProps?.currentSpaceId || currentSpaceId

  const formattedComponentData = formatCommonComponentFields(
    data,
    activeLocale,
    activeSiteIdentifier,
    activeHomepageSlug,
    activeCurrentSpaceId
  )
  
  const formatDetailList = data?.recommendationListItems?.map(item => {
    return {
      text: item?.value,
      icon:
        item?.listItemIcon?.toLowerCase() === "check"
          ? "t2u-check"
          : item?.listItemIcon?.toLowerCase() === "x"
          ? "t2u-close"
          : "",
    }
  })
  const imageSizesOverride = {
    desktop: {
      width: data?.media?.image?.file?.details?.image?.width,
      height: data?.media?.image?.file?.details?.image?.height,
      ratio: {
        width: data?.media?.image?.file?.details?.image?.width,
        height: data?.media?.image?.file?.details?.image?.height,
      }
    },
    tablet: {
      width: data?.media?.image?.file?.details?.image?.width,
      height: data?.media?.image?.file?.details?.image?.height,
      ratio: {
        width: data?.media?.image?.file?.details?.image?.width,
        height: data?.media?.image?.file?.details?.image?.height,
      }
    },
    mobile: {
      width: data?.media?.image?.file?.details?.image?.width,
      height: data?.media?.image?.file?.details?.image?.height,
      ratio: {
        width: data?.media?.image?.file?.details?.image?.width,
        height: data?.media?.image?.file?.details?.image?.height,
      }
    }
  }

  const content = {
    ...formattedComponentData,
    isWrapped: true,
    recommendationImage: data?.media?.bynderAssetReference?.[0] 
      ? formatFocusedImage({
      image: { file: { url: data?.media?.bynderAssetReference?.[0]?.src } },
      title: data?.media?.altText || data?.media?.title
    }) 
      : data?.media?.image 
        ? formatFocusedImage(data?.media) 
        : null,
    recommendationIcon: formatIcons(data?.recommendationHeaderIcon),
    details: formatDetailList,
    description: <RichTextConnector data={{ content: data?.description }} />,
    buttons: data?.buttons?.map((button, i) => {
      const formattedButton = formatPageLinks(
        button,
        activeLocale,
        button?.url?.__typename,
        activeHomepageSlug,
        activeCurrentSpaceId,
        activeSiteIdentifier
      )
      return {
        ...button,
        label: formattedButton?.text,
        destination: formattedButton?.url,
        primary: data?.buttons?.length > 1 ? i === 0 : true,
      }
    }),
  }
  return (
    <LayoutRecommendations {...content} overrideImageSizes={imageSizesOverride} />
  )
}

export default FormatAndRenderLayoutProductRecommendations
